module.exports = __webpack_public_path__ + "img/app_store.0b1e90d8.png";